var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUpBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/->/>bas/Fill/Noir",
    className: "st0-fill",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,16 C11.744,16 11.488,15.902 11.293,15.707 L5.293,9.707 C4.902,9.316 4.902,8.684 5.293,8.293 C5.684,7.902 6.316,7.902 6.707,8.293 L12,13.586 L17.293,8.293 C17.684,7.902 18.316,7.902 18.707,8.293 C19.098,8.684 19.098,9.316 18.707,9.707 L12.707,15.707 C12.512,15.902 12.256,16 12,16",
    transform: "rotate(180 12 12)",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpBlack);
export default __webpack_public_path__ + "static/media/chevron_up_black.383ab5ca06790ceef28824d2c7dbfcfc.svg";
export { ForwardRef as ReactComponent };